import React from 'react';
import ReactDOM from 'react-dom/client'; // ✅ new import path
import App from './App';

const rootElement = document.getElementById('root');

// ✅ use createRoot instead of render
const root = ReactDOM.createRoot(rootElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);